<template>
  <div
    data-testid="page-drop-zone"
    class="flex min-h-[100px] flex-col items-center justify-center gap-2 rounded-md border border-dashed border-main px-3 py-5"
    :class="{ 'bg-surface-elevation-1': active }"
    @drop.prevent="handleDrop"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
  >
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps<{ accept?: string[] }>()

const emits = defineEmits<{ filesDropped: [File[]] }>()

const active = ref(false)

const setActive = () => (active.value = true)
const setInactive = () => (active.value = false)

const isAcceptedFile = (file: File) => {
  return (props.accept ?? []).some((type) =>
    type.startsWith('.') ? type === '.' + file.name.split('.').pop()?.toLowerCase() : type === file.type.toLowerCase(),
  )
}

const handleDrop = (e: DragEvent) => {
  setTimeout(setInactive, 50)
  const fList = [...(e.dataTransfer?.files || [])]
  const acceptedList = fList.filter((f) => (!props.accept?.length ? true : isAcceptedFile(f)))
  emits('filesDropped', [...acceptedList])
}
</script>
